import pdfMake from "../pdfMakeConfig";
import { formatFecha, formatDateTimeFront } from "../dateFormatter";
import logo from "../transkyriosB64";

export const generarPDF = (datos = {}) => {
  const { cabecera = {}, detalle = [] } = datos;

  const fechaImpresion = formatFecha(new Date(), '/');

  // Helpers Bueno / Revisar / Falta 
  const yesNoIcon = (val, target) => (val === target ? '●' : '○');

  const buenoCell  = (val) => ({ 
    text: yesNoIcon(val, 'bueno'),   
    alignment: "center", 
    font: "DejaVu", 
    color: val === 'bueno' ? '#009b0a' : '#bbb'
  });
  const revisarCell = (val) => ({ 
    text: yesNoIcon(val, 'revisar'), 
    alignment: "center", 
    font: "DejaVu",
    color: val === 'revisar' ? '#ddc700' : '#bbb',
  });
  const faltaCell  = (val) => ({
    text: yesNoIcon(val, 'falta'),
    alignment: "center",
    font: "DejaVu",
    color: val === 'falta' ? '#c62828' : '#bbb',
  });

  const opcionesRow = (label, val, rowIndex) => ([
    { text: label, style: "qLabel" },
    buenoCell(val),
    revisarCell(val),
    faltaCell(val),
  ]);

  // Helpers Sí / No 
  const siNoRow = (label, val) => ([
    { text: label, style: "qLabel" },
    {
      text: val === 'si' ? '●' : '○',
      alignment: "center",
      font: "DejaVu",
      color: val === 'si' ? '#009b0a' : '#bbb',
      bold: val === 'si',
    },
    {
      text: val === 'no' ? '●' : '○',
      alignment: "center",
      font: "DejaVu",
      color: val === 'no' ? '#c62828' : '#bbb',
      bold: val === 'no',
    },
  ]);

  // Agrupar detalle por grupo 
  const grupos = (Array.isArray(detalle) ? detalle : []).reduce((acc, item) => {
    if (!acc[item.grupo]) acc[item.grupo] = {};
    acc[item.grupo][item.pregunta] = item.respuesta;
    return acc;
  }, {});

  // Etiquetas 
  const etiquetas = {
    doc_revisionTecnica:    "Revisión Técnica",
    doc_permisoCirculacion: "Permiso de Circulación",
    doc_soap:               "SOAP",
    doc_emisionGases:       "Emisión de Gases",
    doc_padron:             "Padrón del vehículo",
    doc_laminaSeguridad:    "Certificado Lámina de Seguridad",
    botiquin:               "Botiquín",
    chaleco:                "Chaleco reflectante",
    lentes:                 "Lentes de seguridad",
    guantes:                "Guantes de seguridad",
    bloqueador:             "Bloqueador solar",
    utilesAseo:             "Útiles de aseo",
    camaraInterior:         "Cámara interior",
    camaraExterior:         "Cámara exterior",
    extintorPin:            "Extintor con pin intacto",
    extintorCargado:        "Extintor con carga vigente",
    triangulos:             "Triángulos reflectantes de seguridad",
    gata:                   "Gata hidráulica",
    llaveRuedas:            "Llave para ruedas",
    cunas:                  "Cuñas para ruedas",
    ganchoRemolque:         "Gancho de remolque",
    lucesBajas:             "Luces bajas",
    lucesAltas:             "Luces altas",
    lucesDireccionales:     "Luces direccionales",
    lucesEmergencia:        "Luces de emergencia",
    lucesReversa:           "Luces de reversa",
    lucesAntiniebla:        "Luces antiniebla",
    lucesCabina:            "Luces de cabina",
    frenos:                 "Frenos",
    alarmaRetroceso:        "Alarma de retroceso",
    parabrisas:             "Parabrisas sin daños",
    limpiaparabrisas:       "Limpiaparabrisas",
    vidriosLaterales:       "Vidrios laterales",
    espejosLaterales:       "Espejos laterales",
    limpiaparabrisasTrasero:"Limpiaparabrisas trasero",
    vidrioTrasero:          "Vidrio trasero",
    espejoRetrovisor:       "Espejo retrovisor",
    aceiteMotor:            "Aceite de motor",
    refrigerante:           "Refrigerante",
    direccion:              "Dirección",
    liquidoFrenos:          "Líquido de frenos",
    aguaLimpiaparabrisas:   "Agua limpiaparabrisas",
    adBlue:                 "AdBlue",
    desgasteDD:             "Desgaste neumático delantero derecho",
    desgasteDI:             "Desgaste neumático delantero izquierdo",
    desgasteTD:             "Desgaste neumático trasero derecho",
    desgasteTI:             "Desgaste neumático trasero izquierdo",
    desgasteRepuesto:       "Desgaste neumático repuesto",
    presionDD:              "Presión neumático delantero derecho",
    presionDI:              "Presión neumático delantero izquierdo",
    presionTD:              "Presión neumático trasero derecho",
    presionTI:              "Presión neumático trasero izquierdo",
    presionRepuesto:        "Presión neumático repuesto",
    asientos:               "Estado asientos",
    tapiceria:              "Estado tapicería",
    aseoVehiculo:           "Aseo del vehículo",
    manillasPuertas:        "Manillas de puertas",
    segurosPuertas:         "Seguros de puertas",
    alzavidrios:            "Alzavidrios",
    ajustePuertas:          "Ajuste de puertas",
    bocina:                 "Bocina",
    logosImpresos:          "Logos impresos",
    cinturones:             "Cinturones de seguridad",
    mandosElectricos:       "Mandos eléctricos",
    tableroControles:       "Tablero de controles",
    aireAcondicionado:      "Aire acondicionado",
    frenoMano:              "Freno de mano",
    correas:                "Correas del motor",
    ref_daniosVisibles:     "Daños visibles",
    ref_obstruccion:        "Obstrucción",
    ref_mangueras:          "Estado de mangueras",
    ref_ventiladores:       "Estado de ventiladores",
    ref_ruidos:             "Ruidos en ventiladores",
    ref_revisionTemp:       "Revisión de temperatura",
    ref_limpiezaGral:       "Limpieza general",
    ref_sensoresTemp:       "Estado sensores de temperatura",
    ref_puertasSellos:      "Estado puertas y sellos",
    ref_cierreHermetico:    "Estado cierre hermético",
    ref_tempInicial:        "Temperatura inicial",
  };

  const GRUPOS_SI_NO = new Set(["Documentación", "Seguridad personal"]);

  // Tabla Bueno / Revisar / Falta 
  const tablaEstado = (nombreGrupo, preguntas) => ({
    stack: [
      {
        table: {
          widths: ["100%"],
          body: [[{ text: nombreGrupo, style: "groupHeader" }]],
        },
        layout: "noBorders",
        margin: [0, 0, 0, 2],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", 38, 38, 38],
          body: [
            [
              { text: "Elemento",  style: "th" },
              { text: "Bueno",     style: "thCenter" },
              { text: "Revisar",   style: "thCenter" },
              { text: "Falta",     style: "thCenter" },
            ],
            ...Object.entries(preguntas).map(([codigo, respuesta], i) =>
              opcionesRow(etiquetas[codigo] || codigo, respuesta, i)
            ),
          ],
        },
        layout: {
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return "#1a3a5c";
            return rowIndex % 2 === 0 ? "#f4f6f9" : null;
          },
          hLineColor: "#dde3ea",
          vLineColor: "#dde3ea",
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
        },
        margin: [0, 0, 0, 10],
      },
    ],
  });

  // Tabla Sí / No 
  const tablaSiNo = (nombreGrupo, preguntas) => ({
    stack: [
      {
        table: {
          widths: ["100%"],
          body: [[{ text: nombreGrupo, style: "groupHeader" }]],
        },
        layout: "noBorders",
        margin: [0, 0, 0, 2],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", 30, 30],
          body: [
            [
              { text: "Elemento", style: "th" },
              { text: "Sí",       style: "thCenter" },
              { text: "No",       style: "thCenter" },
            ],
            ...Object.entries(preguntas).map(([codigo, respuesta], i) =>
              siNoRow(etiquetas[codigo] || codigo, respuesta, i)
            ),
          ],
        },
        layout: {
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return "#1a3a5c";
            return rowIndex % 2 === 0 ? "#f4f6f9" : null;
          },
          hLineColor: "#dde3ea",
          vLineColor: "#dde3ea",
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
        },
        margin: [0, 0, 0, 10],
      },
    ],
  });

  // Título de sección principal (banda azul oscuro) 
  const tituloPrincipal = (texto, subtexto) => ({
    stack: [
      {
        canvas: [{
          type: "rect",
          x: 0, y: 0,
          w: 532, h: subtexto ? 34 : 22,
          color: "#dce2f5",
        }],
        margin: [0, 10, 0, 0],
      },
      {
        stack: [
          { text: texto, style: "sectionBannerTitle" },
          ...(subtexto ? [{ text: subtexto, style: "sectionBannerSub" }] : []),
        ],
        margin: [8, subtexto ? -30 : -18, 0, 8],
      },
    ],
  });

  // Separar grupos 
  const seccionesVerificacion = [];   // Documentación + Seguridad personal
  const seccionesInspeccion   = [];   // todo lo demás

  Object.entries(grupos).forEach(([grupo, preguntas]) => {
    if (GRUPOS_SI_NO.has(grupo)) {
      const tieneSiNo = Object.values(preguntas).some(v => v === 'si' || v === 'no');
      if (!tieneSiNo) return;
      seccionesVerificacion.push(tablaSiNo(grupo, preguntas));
    } else {
      seccionesInspeccion.push(tablaEstado(grupo, preguntas));
    }
  });

  // Vigencia de documentos 
  const estadoVigencia = (fechaVigencia, fechaReferencia) => {
    if (!fechaVigencia || !fechaReferencia) return "vigente";
    const fv = new Date(fechaVigencia);
    const fr = new Date(fechaReferencia);
    if (fv < fr) return "vencido";
    const limite = new Date(fr);
    limite.setDate(limite.getDate() + 30);
    return fv <= limite ? "por_vencer" : "vigente";
  };

  const filaVigencia = (label, fecha) => {
    // if (!fecha) return null;
    let estado;
    if(fecha !== 'sin_registro'){
      estado = estadoVigencia(fecha, cabecera.creado_en);
    } else {
      estado = 'sin_registro';
    }
    // const estado = estadoVigencia(fecha, cabecera.creado_en);

    const colores = {
      sin_registro: { bg: "#e2e2e2", fg: "#5f5f5f", etiqueta: "SIN REGISTRO" },
      vencido:    { bg: "#ffbfbf", fg: "#790404", etiqueta: "VENCIDO" },
      por_vencer: { bg: "#ffeebe", fg: "#7a5000", etiqueta: "POR VENCER" },
      vigente:    { bg: "#caf1cc", fg: "#236808", etiqueta: "VIGENTE" },
    };
    const c = colores[estado];

    return [
      { text: label, style: "qLabel" },
      {
        text: formatFecha(fecha) || '-',
        alignment: "center",
        fontSize: 9,
        color: "#111",
      },
      {
        text: `${c.etiqueta}`,
        alignment: "center",
        fontSize: 8,
        bold: true,
        color: c.fg,
        fillColor: c.bg,
        margin: [2, 2, 2, 2],
      },
    ];
  };

  const filasVigencia = [
    filaVigencia("Revisión Técnica",            cabecera.vencRevision || 'sin_registro'),
    filaVigencia("Permiso de Circulación",      cabecera.vencCirculacion || 'sin_registro'),
    filaVigencia("SOAP",                        cabecera.vencSoap || 'sin_registro'),
    filaVigencia("Decreto 80",                  cabecera.vencDecreto80 || 'sin_registro'),
    filaVigencia("Lámina de Seguridad",         cabecera.vencLaminaSeguridad || 'sin_registro'),
    filaVigencia("Mantención Extintor",         cabecera.vencExtintor || 'sin_registro'),
  ].filter(Boolean);

  const seccionVigencia = filasVigencia.length > 0
    ? {
        table: {
          headerRows: 1,
          widths: ["*", 80, 85],
          body: [
            [
              { text: "Documento",        style: "th" },
              { text: "Fecha",            style: "thCenter" },
              { text: "Estado",           style: "thCenter" },
            ],
            ...filasVigencia,
          ],
        },
        layout: {
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return "#1a3a5c";
            return rowIndex % 2 === 0 ? "#f4f6f9" : null;
          },
          hLineColor: "#dde3ea",
          vLineColor: "#dde3ea",
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
        },
        margin: [0, 0, 0, 4],
      }
    : null;

  // ── Observaciones ─────────────────────────────────────────────────────────
  const seccionObservaciones = {
    table: {
      widths: ["*"],
      body: [[{
        text: cabecera.observaciones || "Sin observaciones registradas.",
        style: "obsText",
        margin: [8, 8, 8, 40],
      }]],
    },
    layout: {
      fillColor: () => "#fafbfc",
      hLineColor: "#dde3ea",
      vLineColor: "#dde3ea",
      hLineWidth: () => 0.5,
      vLineWidth: () => 0.5,
    },
    margin: [0, 0, 0, 14],
  };

  const seccionesPrincipales = [
    seccionVigencia ? { titulo: "VIGENCIA DE DOCUMENTOS", contenido: seccionVigencia } : null,
    seccionesVerificacion.length > 0 ? {
      titulo: "VERIFICACIÓN DE VEHÍCULO",
      subtitulo: "Confirme que los siguientes ítems de seguridad personal y documentación se encuentren físicamente en el vehículo",
      contenido: seccionesVerificacion,
    } : null,
    seccionesInspeccion.length > 0 ? {
      titulo: "INSPECIÓN DEL VEHÍCULO",
      contenido: seccionesInspeccion,
    } : null,
    { titulo: "OBSERVACIONES", contenido: seccionObservaciones },
  ].filter(Boolean);

  const romanos = ["I", "II", "III", "IV", "V"];

  const docDefinition = {
    info: {
      title: `Checklist Vehículo - ${cabecera.conductor || "Conductor"} - ${cabecera.fechaRe || ""}`,
      author: "Transkyrios",
    },
    pageSize: "letter",
    pageMargins: [40, 95, 40, 60],
    
    // Encabezado
    header: {
      margin: [40, 22, 40, 0],
      stack: [
        {
          table: {
            widths: ["22%", "56%", "22%"],
            body: [[
              {
                alignment: "center",
                stack: [
                  { 
                    image: logo,
                    width: 150,
                    alignment: "left",
                    margin: [0, -10, 0, 0],
                  },
                  { 
                    text: "TRANSKYRIOS SpA.", 
                    style: "headerSubtitle", 
                    alignment: "center",  
                    margin: [20, -10, -20, 0],
                  },
                  { 
                    text: "RUT 76565005-2", 
                    style: "headerSubtitle", 
                    alignment: "center",  
                    margin: [20, 0, -20, 0],
                  },
                ]
              },
              {
                alignment: "center",
                stack: [
                  { 
                    text: "REGISTRO ESTADO DEL VEHÍCULO", 
                    style: "headerTitle" 
                  },
                  { 
                    text: "Checklist de Inspección Vehicular", 
                    style: "headerSubtitle" 
                  },
                  { 
                    text: `Fecha de impresión: ${fechaImpresion}`, 
                    style: "headerMeta" 
                  },
                ],
              },
              {
                alignment: "right",
                margin: [0, 6, 0, 0],
                stack: [
                  { 
                    text: "N° CHECKLIST", 
                    style: "headerMetaLabel" 
                  },
                  { 
                    text: cabecera.cod_checklist || "CHK-000000", 
                    style: "headerMetaValue" 
                  },
                ],
              },
            ]],
          },
          layout: "noBorders",
        },
        {
          canvas: [{
            type: "line",
            x1: 0, y1: 4,
            x2: 532, y2: 4,
            lineWidth: 2,
            lineColor: "#1a3a5c",
          }],
        },
      ],
    },

    // Contenido
    content: [
      // IDENTIFICACIÓN
      {
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              { text: "Conductor",  style: "idHeader" },
              { text: "Vehículo",   style: "idHeader" },
            ],
            [
              {
                text: [
                  { text: cabecera.conductor || "-", style: "idName" },
                  { text: "   ( " },
                  { text: cabecera.rut_conductor || "-", style: "idSub" },
                  { text: " )" }
                ],
                alignment: "center",
                margin: [6, 4, 6, 6],
              },
              {
                text: [
                  { text: cabecera.patente || "-", style: "idName" },
                  { text: "   ( " },
                  { text: cabecera.tipo_vehiculo || "-", style: "idSub" },
                  { text: " )" }
                ],
                alignment: "center",
                margin: [6, 4, 6, 6],
              },
            ],
            [
              {
                text: `Fecha y hora de registro: ${formatDateTimeFront(cabecera.creado_en) || "-"}`,
                colSpan: 2,
                style: "idFooter",
                margin: [6, 4, 6, 4],
              },
              {},
            ],
          ],
        },
        layout: {
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return "#1a3a5c";
            if (rowIndex === 2) return "#f4f6f9";
            return null;
          },
          hLineColor: "#dde3ea",
          vLineColor: "#dde3ea",
          hLineWidth: () => 0.5,
          vLineWidth: (i, node) => (i === 1 ? 1 : 0.5),
        },
        margin: [0, 0, 0, 4],
      },

      // Secciones numeradas dinámicamente
      ...seccionesPrincipales.flatMap(({ titulo, subtitulo, contenido }, i) => {
        const encabezado = tituloPrincipal(`${romanos[i]}. ${titulo}`, subtitulo);
        return Array.isArray(contenido)
          ? [encabezado, ...contenido]
          : [encabezado, contenido];
      }),

    ].filter(Boolean),

    footer: (currentPage, pageCount) => ({
      margin: [40, 8, 40, 0],
      columns: [
        {
          text: `${cabecera.conductor || ""} — ${cabecera.patente || ""}`,
          fontSize: 7,
          color: "#888",
          alignment: "left",
        },
        {
          text: `Página ${currentPage} de ${pageCount}`,
          fontSize: 7,
          color: "#888",
          alignment: "right",
        },
      ],
    }),

    styles: {
      // Header del documento
      headerTitle:     { fontSize: 12, bold: true,  color: "#0d2137", margin: [0, 2, 0, 1] },
      headerSubtitle:  { fontSize: 9,  color: "#445566"  },
      headerMeta:      { fontSize: 8,  color: "#778899", margin: [0, 3, 0, 0] },
      headerMetaLabel: { fontSize: 7,  bold: true,  color: "#778899", characterSpacing: 0.5 },
      headerMetaValue: { fontSize: 11, bold: true,  color: "#0d2137"  },

      // Identificación
      idHeader: { fontSize: 9,  bold: true, color: "#ffffff", alignment: "center" },
      idName:   { fontSize: 10, bold: true, color: "#0d2137" },
      idSub:    { fontSize: 10, color: "#556677"  },
      idFooter: { fontSize: 10, color: "#556677", alignment: "center" },

      // Banda de sección principal
      sectionBannerTitle: { fontSize: 10, bold: true, color: "#0d2137",  characterSpacing: 0.3 },
      sectionBannerSub:   { fontSize: 7.5,            color: "#556677"                        },

      // Encabezado de grupo (subgrupo dentro de sección)
      groupHeader: { fontSize: 9, bold: true, color: "#1a3a5c", margin: [0, 6, 0, 0] },

      // Tablas
      th:        { bold: true, fontSize: 8,  color: "#ffffff"  },
      thCenter:  { bold: true, fontSize: 8,  color: "#ffffff", alignment: "center" },
      qLabel:    { fontSize: 8.5,            color: "#1a1a1a"  },

      // Observaciones
      obsText:   { fontSize: 9, color: "#333", alignment: "left", lineHeight: 1.5 },
    },

    defaultStyle: { font: "Roboto", fontSize: 9 },
  };

  return pdfMake.createPdf(docDefinition);
};